<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  orderTimeCarrierEdit,
  orderTimeDetail,
} from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/operate/order/deal/orderDetailTab/carrier/edit',
      formComponents: ['baseForm'],
    };
  },
  watch: {
    '$route.query.orderId': async function (newVal) {
      if (this.$route.path === '/manage/operate/order/deal/orderDetailTab/carrier/edit') {
        await this.$refs.baseForm.getList();
        this.getData();
      }
    },
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
        orderId: this.$route.query.orderId,
      };
    },
  },
  methods: {
    detailApi: orderTimeDetail,
    editApi: orderTimeCarrierEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
